module.exports = __webpack_public_path__ + "static/banner-new-1099d8d873c957d10aee634506cf9245.jpg";